import { Box, Container, Grid, Typography, Stack, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {motion} from "framer-motion"

const Collage_Section = () => {
  return (
    <Box py={10}>
      <Container maxWidth="lg">
        {/* MAIN GRID */}
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <Grid container spacing={4}>
            {/* LEFT IMAGES */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Box sx={{}}>
                <img
                  src="https://rstheme.com/products/wordpress/konstruk/wp-content/uploads/2023/03/construct-building.png"
                  alt="Construction building collage"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 8,
                  }}
                />
              </Box>
            </Grid>

            {/* RIGHT CONTENT */}
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="subtitle2" className="paraAfter-line">
                WHAT WE CONTRIBUTE
              </Typography>
              <Typography
                variant="h1"
                className="headPara"
                fontWeight={700}
                sx={{ mt: 1, mb: 3, lineHeight: 1.3 }}
              >
                Construction Materials & Infrastructure Support Experts
              </Typography>

              <Typography variant="body1" sx={{ mb: 4 }}>
              We support large-scale construction and infrastructure projects by supplying high-quality sand, aggregates, bricks, and construction materials backed by efficient logistics. From mining and sourcing to on-site delivery, we ensure consistency, compliance, and timely supply across the state.we understand project timelines, volume requirements, and on-site delivery precision.
              </Typography>

              {/* FEATURES GRID */}
              <Grid container spacing={2}>
                {/* LEFT COLUMN */}
                <Grid size={{ xs: 6 }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CheckCircleIcon
                      sx={{ color: "#fec810", fontSize: "25px" }}
                    />
                    <Typography>Commercial Projects</Typography>
                  </Stack>

                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ mt: 1 }}
                  >
                    <CheckCircleIcon
                      sx={{ color: "#fec810", fontSize: "25px" }}
                    />
                    <Typography>Residential Developments</Typography>
                  </Stack>

                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ mt: 1 }}
                  >
                    <CheckCircleIcon
                      sx={{ color: "#fec810", fontSize: "25px" }}
                    />
                    <Typography>Educational Institutions</Typography>
                  </Stack>
                </Grid>

                {/* RIGHT COLUMN */}
                <Grid size={{ xs: 6 }}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <CheckCircleIcon
                      sx={{ color: "#fec810", fontSize: "25px" }}
                    />
                    <Typography>Hospitals & Healthcare Facilities</Typography>
                  </Stack>

                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ mt: 1 }}
                  >
                    <CheckCircleIcon
                      sx={{ color: "#fec810", fontSize: "25px" }}
                    />
                    <Typography>Bridges, Roads & Highways</Typography>
                  </Stack>

                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ mt: 1 }}
                  >
                    <CheckCircleIcon
                      sx={{ color: "#fec810", fontSize: "25px" }}
                    />
                    <Typography>Gas & Mining Projects</Typography>
                  </Stack>
                </Grid>
              </Grid>

              {/* BUTTON */}
              <Box sx={{ marginTop: "50px" }}>
                <Button class="btn-default" role="button">
                  Discover More
                </Button>
              </Box>
            </Grid>
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Collage_Section;
